import { MessageBubble } from "./MessageBubble";
import { Message } from "@/types/message";

interface ChatThreadProps {
  messages: Message[];
  editingMessageIds: Set<string>;
  onEditMessage: (messageId: string) => void;
  onCancelEdit: (messageId: string) => void;
  onSaveEdit: (messageId: string, content: string) => void;
  onSummarize: (summary: string) => void;
  onSend: (messageId: string, summary: string) => void;
}

export const ChatThread = ({ 
  messages, 
  editingMessageIds,
  onEditMessage,
  onCancelEdit,
  onSaveEdit,
  onSummarize,
  onSend
}: ChatThreadProps) => {
  return (
    <div className="px-4 py-6">
      <div className="space-y-6">
        {messages.map((message) => (
          <MessageBubble
            key={message.id}
            message={message}
            onEdit={onEditMessage}
            isEditing={editingMessageIds.has(message.id)}
            onCancelEdit={() => onCancelEdit(message.id)}
            onSaveEdit={(content) => onSaveEdit(message.id, content)}
            onSummarize={onSummarize}
            onSend={(summary) => onSend(message.id, summary)}
          />
        ))}
      </div>
    </div>
  );
};
